var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from 'react';
import { FormHelperText as MuiFormHelperText, } from '@mui/material';
import styles from './FormHelperText.module.scss';
const FormHelperText = (_a) => {
    var { children, error, errors, helperText } = _a, props = __rest(_a, ["children", "error", "errors", "helperText"]);
    const label = useMemo(() => {
        if (error) {
            if (typeof error === 'object' && error.message)
                return error.message;
            if (typeof error === 'string')
                return error;
        }
        const concatErrors = errors ? errors.map((item) => item.message) : [];
        const helpMessage = helperText || concatErrors.join('\n');
        return helpMessage;
    }, [helperText, error, errors]);
    return (React.createElement(MuiFormHelperText, Object.assign({ className: [
            styles.helperText,
            error || (errors && errors.length) ? styles.helperTextError : '',
        ].join(' ') }, props), children || label));
};
export default FormHelperText;
